// extracted by mini-css-extract-plugin
module.exports = {"hidden":"NewPointOfInterestForm_hidden__11Qwq","overrideAddress":"NewPointOfInterestForm_overrideAddress__1u3gB"};